/**
 * La vue d'aigle — `GET /v1/console/vue-d-aigle` (spec 2026-10-01, § 5 ;
 * ARTO-58).
 *
 * Une projection AGRÉGÉE de la base plateforme, calculée par l'API et
 * filtrée côté serveur selon le rôle. Ce fichier n'en porte que la forme :
 * la console l'importe sans tirer aucune dépendance serveur.
 *
 * Deux vues pour un même type :
 *
 *   - `associe` — ce que voit l'associé de Venio, ou un rôle opérationnel en
 *     « Voir comme un associé ». Aucun nom ni identifiant de galerie, de
 *     groupe ou de débiteur, nulle part ; `parc.detail`, `aTraiter` et
 *     `abonnements` sont ABSENTS (pas vides : absents) ; `partage` réduit aux
 *     lignes du compte qui regarde ;
 *   - `admin` — la même chose, plus le détail par galerie, le bloc « À
 *     traiter » et la liste des abonnements.
 *
 * Tout montant est en centimes. `Montant` vaut `null` quand il est « à
 * saisir » : il n'entre dans aucun total, et les compteurs `aSaisir` disent
 * combien de lignes un total ignore.
 */
import { z } from 'zod';
/** Fenêtre des courbes et des versements : 30 jours, 90 jours, 12 mois. */
export const PERIODES_VUE_D_AIGLE = ['30j', '90j', '12m'];
export const periodeVueDAigleSchema = z.enum(PERIODES_VUE_D_AIGLE);
/** Les deux vues. Un associé reçoit `associe`, quoi qu'il demande. */
export const NOMS_VUE_D_AIGLE = ['associe', 'admin'];
export const nomVueDAigleSchema = z.enum(NOMS_VUE_D_AIGLE);
//# sourceMappingURL=vue-d-aigle.js.map